import React from 'react'
import { useResizeDetector } from 'react-resize-detector'

export default function withDimensions(Component) {
  function WithDimensions(props) {
    const { height, ref, width } = useResizeDetector()

    return (
      <Component {...props} height={height} targetRef={ref} width={width} />
    )
  }

  WithDimensions.displayName = `withDimensions(${Component.displayName ||
    Component.name ||
    'Component'})`

  return WithDimensions
}
